import { render, staticRenderFns } from "./AdminFaqList.vue?vue&type=template&id=fba0d680&scoped=true&"
import script from "./AdminFaqList.vue?vue&type=script&lang=js&"
export * from "./AdminFaqList.vue?vue&type=script&lang=js&"
import style0 from "./AdminFaqList.vue?vue&type=style&index=0&id=fba0d680&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba0d680",
  null
  
)

export default component.exports